function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 1,
  width: 18,
  height: 19,
  rx: 1,
  fill: "#A8FFF8"
});
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10,
  cy: 22.5,
  rx: 9,
  ry: 6.5,
  fill: "#CBFF88"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 9h15v12h-7l-6 4v-4.5H3V9z",
  fill: "#14454C",
  fillOpacity: 0.15
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 3.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v14a.5.5 0 01-.5.5H24v3.5a.5.5 0 01-.777.416L17.349 18H9.5a.5.5 0 01-.5-.5v-14zm1 .5v13h7.5a.5.5 0 01.277.084L23 20.566V17.5a.5.5 0 01.5-.5H26V4H10z",
  fill: "#14454C"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#14454C",
  strokeLinecap: "round",
  d: "M12.5 8.5h11M12.5 13.5h11"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.5h-4V21h3v4l5.5-4h7.5",
  stroke: "#14454C",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDiscussion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default __webpack_public_path__ + "fonts/discussion-009bde06c9cba67ef2b0340c8df0ffd6.svg";
export { SvgDiscussion as ReactComponent };